<tcc-simplePanel [size]="panalSize" [buttons]="['close']" (buttonClick)="close()">

    <div panel-header *ngIf="state === 'ready'">
        <div *ngIf="addOrEdit === 'add'">Add Org Mapping Lookup</div>
        <div *ngIf="addOrEdit === 'edit'">Edit {{currentOrgMappingLookup?.name}}</div>
    </div>

    <div panel-body *ngIf="state === 'ready'">
        <div class="container">
            <div class="row">
                <div class="col-12" style="text-align: center;">
                    <h4>Org Mapping Lookup</h4>
                </div>
            </div>

            <form [formGroup]="orgMappingLookupFormGroup" (ngSubmit)="onSubmit()">

                <input type="number" formControlName="id" hidden>

                <label for="name">Name: </label>
                <input type="text"
                       formControlName="name"
                       [ngClass]="{changed: isChanged('name')}"
                       name="name"
                       #name>

                <label for="meta">Meta: </label>
                <textarea formControlName="meta"
                          class="meta-textarea"  
                          [ngClass]="{changed: isChanged('meta')}"
                          name="meta"
                          #meta></textarea>

                <div style="margin-top: 10px;">
                    <button type="submit" [disabled]="!orgMappingLookupFormGroup.valid ||
                                                      !orgMappingLookupFormGroup.dirty">Save</button>
                </div>
            </form>
        </div>
    </div>

</tcc-simplePanel>
<tcc-loadingOverlay *ngIf="state !== 'ready'"></tcc-loadingOverlay>
